import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !['cover'].includes(prop),
})`
  cursor: pointer;
  position: relative;
  background-color: ${(props) =>
    props.theme.mixin.rgba(props.theme.colors.mineShaft2, 0.3)};
  background-image: url(${(props) => getUrlWithToken(props.cover)});
  background-size: cover;
  background-position: center center;
  width: ${(props) => (props.small ? '210px' : '220px')};
  height: ${(props) => (props.small ? '175px' : '240px')};
  border-radius: 8px;
  padding: 15px 20px;
  transition: ${(props) => props.theme.constants.transitionBase};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;

  &:before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(0, 0, 0, 0.8)
    );
    border-radius: 8px;
    transition: ${(props) => props.theme.constants.transitionBase};
  }

  &:hover {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
    &:before {
      background-color: ${(props) =>
        props.theme.mixin.rgba(props.theme.colors.doveGray, 0.6)};
    }
  }
`;

export const EventInfo = styled.div`
  overflow: hidden;
  display: -webkit-inline-box;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;
